var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2628_7736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.188 4H21.188V6H11.188V4ZM11.188 8H17.188V10H11.188V8ZM11.188 14H21.188V16H11.188V14ZM11.188 18H17.188V20H11.188V18ZM3.18799 4H9.18799V10H3.18799V4ZM5.18799 6V8H7.18799V6H5.18799ZM3.18799 14H9.18799V20H3.18799V14ZM5.18799 16V18H7.18799V16H5.18799Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2628_7736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.187988)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.cea9dcba49d65aedcf7b47965a0f72b1.svg";
export { ForwardRef as ReactComponent };